import styled, { CSSObject } from '@emotion/styled';

import { getSemanticColorVariable } from '../../theme/colors';

// Local Typings
export type InputSize = 'large' | 'small';
export interface InputFieldProps {
  alignment?: 'center' | 'left' | 'right';
  cursor?: 'auto' | 'pointer';
  inputSize?: InputSize;
  minHeight?: number;
  minWidth?: number;
  rows?: number;
  smallFont?: boolean;
}
interface LocalInputFieldProps {
  as?: 'input' | 'textarea';
  inputHeight: number | string;
  isTextArea: boolean;
  resize?: CSSObject['resize'];
}

// Local Variables
export const inputFontSize = 14;
export const inputHeightLarge = 36;
export const inputHeightSmall = 32;
export const inputLineHeight = 1.5;

// Component Definition
const InputField = styled.input<InputFieldProps & LocalInputFieldProps>(({
  alignment = 'left',
  cursor = 'auto',
  inputHeight: height = '100%',
  inputSize = 'large',
  isTextArea,
  minWidth = 100,
  resize,
  rows = 1,
  smallFont,
  theme,
}) => ({
  background: 'none',
  border: 'none',
  color: getSemanticColorVariable('text_default'),
  cursor,
  flexGrow: 1,
  fontSize: smallFont ? 12 : inputFontSize,
  height,
  lineHeight: `${inputLineHeight}em`,
  minHeight: rows * (inputSize === 'large' ? inputHeightLarge : inputHeightSmall),
  minWidth,
  outline: 'none',
  padding: isTextArea ? `${theme.spacing * 2}px ${theme.spacing * 3}px` : `0 ${theme.spacing * 3}px`,
  resize,
  textAlign: alignment,
  width: '100%',

  /* eslint-disable sort-keys,@typescript-eslint/naming-convention */
  '&::placeholder': {
    color: getSemanticColorVariable('input_placeholder'),
  },
  '&:disabled': {
    cursor: 'not-allowed',
    WebkitTextFillColor: getSemanticColorVariable('input_placeholder'),
    color: getSemanticColorVariable('input_placeholder'),
    opacity: 1,
  },
  /* eslint-enable sort-keys,@typescript-eslint/naming-convention */
}));

export default InputField;
